/*
 * @Author: Latte
 * @Date: 2021-08-19 17:31:42
 * @LAstEditors: Latte
 * @LastEditTime: 2021-12-28 11:32:15
 * @FilePath: \Siui.Cloud.Medical.Web\src\api\mai\liveManagement\ADManagement.js
 */
import request from '@/utils/request'
import config from '@/utils/config'
import Qs from 'qs'

/**
 * 广告管理接口
 */

/**
 * @description: 获取广告视频列表
 * @param {*} params
 * @return {*}
 */
export function getAdvertisementList(params) {
  return request({
    url: config.API_LIVE + '/live_server/manage/live/list/advertisement',
    method: 'get',
    params
  })
}

/**
 * @description: 批量启动广告
 * @param {*} data
 * @return {*}
 */
export function startAdvertisement(data) {
  return request({
    url: config.API_LIVE + '/live_server/manage/live/advertisements/start',
    method: 'post',
    data: Qs.stringify(data)
  })
}

/**
 * @description: 批量停止广告
 * @param {*} data
 * @return {*}
 */
export function stopAdvertisement(data) {
  return request({
    url: config.API_LIVE + '/live_server/manage/live/advertisements/stop',
    method: 'post',
    data: Qs.stringify(data)
  })
}

/**
 * @description: 批量删除广告
 * @param {*} params
 * @return {*}
 */
export function deleteAdvertisement(params) {
  return request({
    url: config.API_LIVE + '/live_server/manage/live/advertisements/delete',
    method: 'delete',
    params
  })
}

/**
 * @description: 新增广告视频
 * @param {*} data
 * @return {*}
 */
export function addAdvertisement(data) {
  return request({
    url: config.API_LIVE + '/live_server/manage/live/advertisements/add',
    method: 'post',
    data
  })
}